import styled from '@emotion/styled';
import { variant } from '@lucid/theme';
import { AccordionItem as ReactAccordionItem } from 'react-accessible-accordion';

export type AccordionItemVariants = 'default';

export interface AccordionItemProps {
  /** The available variants for the Accordion.Item component. */
  variant?: AccordionItemVariants;
}

const AccordionItem = styled(ReactAccordionItem)<AccordionItemProps>(
  {
    label: 'item',
    display: 'flex',
    flex: '0 1 100%',
    flexWrap: 'wrap'
  },
  variant({
    scale: 'accordion.item',
    variants: {
      defaultVariant: {}
    }
  })
);

export { AccordionItem };
export default AccordionItem;
